import OMath from '@/utils/math'
import {mapActions, mapState} from 'vuex'
import dayjs from 'dayjs'

export default {
  computed: {
    ...mapState('common', [
      'globalOptions',]),
    personTypeist(){
      return[
        {
          name:'个人 Personal',
          id: 1
        },
        {
          name:'公司 Company',
          id: 2
        },
      ]
    },
    brandList(){
      return[
        {
          name:'BYD',
          id: 'BYD'
        },
        {
          name:'DENZA',
          id: 'DENZA'
        },
      ]
    },
    personalIdTypOptions() {
      return [
        {
          name: 'HKID',
          name_zh: '香港身份证号码',
          id: 1
        },
        {
          name: 'Passport',
          name_zh: '护照号码',
          id: 2
        },
      ]
    },
  },
  created() {

  },
  methods: {
    ...mapActions('common', [
      'updateGlobalOptions',
    ]),
    getGlobalOptionName(target, id, key = 'id') {
      let result = ''
      if(this.globalOptions[target])
        this.globalOptions[target].some(item => {
          if (item[key] == id) {
            result = item.name
            return true
          }
          return false
        })
      return result
    },
    getOptionName(target, id, originData) {
      try {
        let data
        if(originData) {
          data= originData
        }
        else {
          const targetArr = target.split('.')
          data = this[targetArr[0]]
          if(targetArr.length > 1) {
            data = this[targetArr[0]][targetArr[1]]
          }
        }

        let result = ''
        data.some(item => {
          if (item.id == id) {
            result = item.name
            return true
          }
          return false
        })
        return result
      } catch (e) {
        console.log(target)
      }
    },
    getAllOptionName(target, id) {
      return this.mixinHandler().getAllOptionName(target, id)
    },
    getOptionData(target, id, originData) {
      let result = {}
      let data = this[target]
      if(originData) {
        data = originData
      }

      data.some(item => {
        if (item.id == id) {
          result = item
          return true
        }
        return false
      })
      return result
    },
    getAreaName(target, id) {
      let result = ''
      this.allOptions.area[target].some(item => {
        if (item.id == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    getAreaData(target, id) {
      let result = {}
      this.allOptions.area[target].some(item => {
        if (item.id == id) {
          result = item
          return true
        }
        return false
      })
      return result
    },
    getAllOptionData(target, id) {
      let result = {}
      this.allOptions[target].some(item => {
        if (item.id == id) {
          result = item
          return true
        }
        return false
      })
      return result
    },
    getExText(ex, posi, pol) {
      if (!ex) { return '- -' }
      let result = ''
      if (posi > 0) {
        result = `${OMath.formatMoney(ex, 0)} or 
        ${posi}% of sum insured whichever is the greater`
      }
      else if (pol > 0) {
        result = `${OMath.formatMoney(ex, 0)} or 
        ${pol}% of lost whichever is the greater`
      } else {
        result = `${OMath.formatMoney(ex, 0)}`
      }
      return result
    },
    mixinHandler() {
      return {
        getAllOptionName: (target, id, classId = '') => {
          // 默認電單車
          let result = ''
          let data = this[`allOptions${classId}`][target] || []
          data.some(item => {
            if (item.id == id) {
              result = item.name
              return true
            }
            return false
          })
          return result
        }
      }
    },
    birthMethod(date){
      return date?dayjs(date).format('YYYY-MM-DD'):''
    },
    changeLineData(data){
      return data?data.replace(/\n/g, '<br/>'):'-'
    },
    changeLineText(data){
      return data?data.replace(/\n/g, '<br/>'):''
    },
    formatText(input) {
      if(input)
      {
        const lines = input.split('\n')
        const urlRegex = /(\b(https?:\/\/|www\.)[^\s]+)/g
        return lines.map(line => {
          return line.replace(urlRegex, (match) => {
            const href = match.startsWith('http') ? match : `http://${match}`
            return `<a href="${href}" target="_blank" class="blue">${match}</a>`
          })
        }).join('<br>')
      }
    },
    showHKTime(time){
      if(time)
      {
        return  dayjs(time).format('DD-MM-YYYY HH:mm:ss')
      }else return  ''
    },
    showHKTimeMin(time,isEnd =false){
      if(time)
      {
        let str = isEnd?'DD-MM-YYYY 23:59':'DD-MM-YYYY HH:mm'
        return  dayjs(time).format(str)
      }else return  ''
    },
    showHKDate(time){
      if(time)
      {
        return  dayjs(time).format('DD-MM-YYYY')
      }else return  ''
    },
    showHKMon(time){
      if(time)
      {
        return  dayjs(time).format('MM-YYYY')
      }else return  ''
    },
    getSMEOptionName(option,id){
      let result = ''
      if(!option) return result
      option.some(item => {
        if (item.id == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    getBankOptionName(id){
      let res = ''
      this.bankList.some(item => {
        if(item.bank_code == id){
          res = item.bank_name
        }
      })
      return res
    },
    check18Years(begin, end) {
      if(!begin || !end) return true

      const years18 = dayjs(begin).add(18, 'years').format('YYYY-MM-DD')
      // 結束那一天也算，加一天來判斷
      const endDate = dayjs(end).add(1, 'day').format('YYYY-MM-DD')
      return dayjs(years18).isBefore(endDate)
    },
    today() {
      let date = new Date()
      const tody = dayjs().format('YYYY-MM-DD')
      return tody
    },
    handlerUser(id){
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
    openUrl(url) {
      if(url){
        window.open(url,'_blank')
      }
    },
  },
}
